/**
 * https://github.com/tugayilik/vue-number-transition-directive
 * 数字计数动画, 从0自动按比例增加/减少到指定目标数字
 * 使用方法: v-numberup="500"
 * 高级用法: v-numberup="{target: 500, spped:50}"
 */

export default {
	bind (el: HTMLElement, binding: any, vnode: any) {
		const defaults = {
			target: 0,
			speed: 100,
			currentIteration: 0,
			iteration: 10,
		};
		let config = Object.assign(defaults, binding.value);
		if (Object.prototype.toString.call(binding.value) == '[object Number]') {
			config.target = binding.value;
			config.speed = 100;
			config.iteration = Math.abs(Math.ceil(config.target / 50));
		}

		const getElementValue = () => Math.round(Number(el.innerText) || 0);
		const getValue = (percent: number) =>
			Math.round((config.target - getElementValue()) * percent + getElementValue());

		const handler = (updatedConfig?: any) => {
			config.currentIteration = 0;
			config = Object.assign(config, updatedConfig);

			(el as any)._updateInterval = setInterval(() => {
				(el as any).innerText = getValue(config.currentIteration / config.iteration);
				config.currentIteration = config.currentIteration + 1;

				if (config.currentIteration >= config.iteration) {
					clearInterval((el as any)._updateInterval);
					(el as any).innerText = config.target;
				}
			}, config.speed / config.iteration);
		};

		(el as any)._numberTransitionHandler = handler;

		handler();
	},
	update (el: HTMLElement, binding: any, vnode: any) {
		(el as any)._numberTransitionHandler(binding.value);
	},
	unbind (el: HTMLElement, binding: any, vnode: any) {
		clearInterval((el as any)._updateInterval);
		(el as any)._numberTransitionHandler = null;
	},
};
